import { render, staticRenderFns } from "./TitlePage.vue?vue&type=template&id=0f7f673e&scoped=true&"
import script from "./TitlePage.vue?vue&type=script&lang=js&"
export * from "./TitlePage.vue?vue&type=script&lang=js&"
import style0 from "./TitlePage.vue?vue&type=style&index=0&id=0f7f673e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7f673e",
  null
  
)

export default component.exports